import React from 'react';

const JS_Asynchronous = () => {
  return (
    <div >
      <h1>JS_Asynchronous</h1>
      <p>Placeholder component for: "JS Asynchronous"</p>
    </div>
  );
};

export default JS_Asynchronous;
